/**************************************
 *  SetForSet – critical.js (2025-05) *
 **************************************/

/* ========= 0. WRAPPER PER SICUREZZA ========= */
document.addEventListener('DOMContentLoaded', () => {
  // 1) INIZIALIZZA nav E cart COME pannelli mmenu
  const $nav  = $('#nav').mmenu({
    navbar: { add: false },
    offCanvas: { pageSelector: '#content_wrapper' }, 
    extensions: [
      `theme-${settings.mobile_menu_color}`,
      'position-front',
      `position-${settings.side_nav_position || 'left'}`
    ]
  });
  const navApi  = $nav.data('mmenu');

  const $cart = $('#cart').mmenu({
    navbar: { add: false },
    offCanvas: { pageSelector: '#content_wrapper' },
    extensions: [
      `theme-${settings.mobile_menu_color}`,
      'position-front',
      `position-${settings.side_cart_position}`
    ]
  });
  const cartApi = $cart.data('mmenu');

  console.log('mmenu nav API:',  navApi);
  console.log('mmenu cart API:', cartApi);

  // 2) Bind dei click per aprire i pannelli
  $('.icon-menu').on('click', e => {
    e.preventDefault();
    if (navApi) navApi.open();
    else console.warn('navApi non disponibile!');
  });

  $('.cart-button').on('click', e => {
    e.preventDefault();
    if (cartApi) cartApi.open();
    else console.warn('cartApi non disponibile!');
    $('#search').hide();
  });

  // 3) Inizializza il resto
  window.header.init();
  announcement_bar.init();
  window.searchAutocomplete.init();
});


/* ========= 1. HEADER ============ */
window.header = {
  init() {
    this.setHeaderPosition();

    // elimina header duplicato su mobile
    if ($('.mobile-header').length > 1) {
      const nav = $('#nav').data('mmenu');
      nav.close();
      $('.mobile-header:last, #nav:last').remove();
    }

    // ancore interne con header sticky
    if ($('.header').hasClass('mm-fixed-top')) {
      $('.menu li:not(.cart) a[href^="#"], .flex-caption a[href^="#"]').on('click', function(e) {
        const id = $(this).attr('href');
        if ($('.index-sections').find(id).length) {
          e.preventDefault();
          const offset = $('.header').outerHeight();
          $('html, body').animate({ scrollTop: $(id).offset().top - offset }, 2000);
        }
      });
    }

    // header sticky sopra la fold
    const feature = $('.feature_image .header.header-background--false');
    if (feature.hasClass('sticky-header--true')) {
      $('.index-sections .shopify-section:nth-child(2), .shopify-section:nth-child(2), .main-wrapper, .page-details-block:nth-child(2)')
        .waypoint((dir) => {
          if (dir === 'down') {
            feature
              .addClass('sticky--active fadeInDown delay-0s header_bar')
              .removeClass('is-absolute');
            this.dynamicDropdown();
          } else {
            feature
              .removeClass('sticky--active fadeInDown delay-0s header_bar')
              .addClass('is-absolute');
            this.dynamicDropdown();
          }
        }, { offset: () => -feature.outerHeight() - 250 });
    }

    // rimuovi classe animazione
    feature.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', function() {
      $(this).removeClass('fadeIn');
    });

    // apri/chiudi ricerca su mobile (rimane qui solo per nascondere #search)
    $('.cart-button, .icon-menu').on('click', () => {
      $('#search').hide();
    });
  },

  setHeaderPosition() {
    if ($('.promo-banner').length) {
      const h = $('.promo-banner').outerHeight();
      $('.header').css('top', h);
    } else {
      $('.header').css('top', '0');
    }
  },

  dynamicDropdown() {
    const barW = $('[data-header-navigation]').width();
    let total = 0;
    $('[data-header-nav-item]').each(function() {
      total += $(this).outerWidth();
    });
    const fits = total <= barW;
    const dropPos = $('.header').data('dropdown-position');

    if (dropPos === 'below_header' && fits) {
      $('.header_bar')
        .removeClass('header-dropdown-position--below_parent')
        .addClass('header-dropdown-position--below_header')
        .attr('data-dropdown-position', 'below_header');
      const pad = $('.header').height() / 2;
      $('.header_bar.header-dropdown-position--below_header .dropdown, .header_bar.header-dropdown-position--below_header .disclosure__list-wrap')
        .css('padding-top', pad);
    } else {
      $('.header')
        .addClass('header-dropdown-position--below_parent')
        .removeClass('header-dropdown-position--below_header')
        .attr('data-dropdown-position', 'below_parent');
      $('.header .dropdown, .header .disclosure__list-wrap').removeAttr('style');
    }
  },

  setPadding() {
    if ($('body').hasClass('promo-banner--true')) {
      const e = $('.promo-banner').innerHeight() - 25 + 'px';
      const section = $('.promo-banner').parent('.shopify-section--header');
      if ($('.header').hasClass('sticky-header--true')) {
        section.css('padding-bottom', e);
      }
    } else {
      const section = $('.promo-banner').parent('.shopify-section--header');
      section.css('padding-bottom', '0');
      $('.header').css('top', '0');
    }
  },

  openDropdown() {
    function toggle(e) {
      e.stopPropagation();
      const details = e.currentTarget;
      const already = details.open;
      $('[data-header-nav-details]').each(function() {
        this.open = false;
        $(this).attr('aria-expanded', 'false');
      });
      if (already && details.querySelector('summary').href) {
        window.location = details.querySelector('summary').href;
      } else {
        details.open = !already;
        $(details).attr('aria-expanded', String(!already));
      }
    }
    $('[data-header-nav-details]').on('click touchend', toggle);
  },

  unload() {
    $('a[href^="#"]').off('click');
    $('[data-header-nav-details]').off('click touchend');
  }
};

/* ========= 2. ANNOUNCEMENT BAR ======== */
var announcement_bar = {
  init() {
    if (!$('.promo-banner').length) return;
    const cookie = Cookies.get('promo-banner');
    if (cookie === 'dismiss') return;
    $('body').addClass('promo-banner--true');
    $('.promo-banner__close').on('click', () => {
      $('body').removeClass('promo-banner--true');
      this.setPadding();
      Cookies.set('promo-banner', 'dismiss', { path: '/', expires: 30 });
    });
    this.setPadding();
  },

  setPadding() {
    const h = $('.promo-banner').innerHeight();
    const pad = h - 25 + 'px';
    const section = $('.promo-banner').parent('.shopify-section--header');
    if ($('body').hasClass('promo-banner--true')) {
      if ($('.header').hasClass('sticky-header--true')) {
        section.css('padding-bottom', pad);
      }
    } else {
      section.css('padding-bottom', '0');
      $('.header').css('top', '0');
    }
  }
};

/* ========= 3. SEARCH AUTOCOMPLETE ===== */
window.searchAutocomplete = {
  vars: { term: '', searchPath: window.PXUTheme.routes.search_url, displayTimer: 0 },

  init() {
    this.unload();
    $('.mobile-search').appendTo('body');
    $('[data-autocomplete-true]').on('focus', 'input', () => {
      $('.search__results-wrapper').show();
    });
    $(document).on('click focusout', (e) => {
      if (window.PXUTheme.media_queries.large.matches) {
        if (!$(e.target).closest('.search__form').length) {
          $('.search__results-wrapper').hide().removeClass('results-found');
        }
      }
    });
    $('[data-autocomplete-true] form').each((_, form) => {
      const $f = $(form);
      $f.append('<div class="search__results-wrapper"><ul class="search__results"></ul></div>');
      $f.find('[name="q"]').attr('autocomplete','off').on('input', () => {
        clearTimeout(this.vars.displayTimer);
        const v = $f.find('[name="q"]').val();
        console.log('Ricerca input:', v);
        if (v.length > 3) {
          this.vars.term = v;
          this.vars.displayTimer = setTimeout(() => this.getResults(v, $f), 300);
        } else {
          $('.search__results-wrapper').hide().removeClass('results-found');
        }
      });
      $f.on('submit', (e) => {
        e.preventDefault();
        const q = encodeURIComponent($f.find('[name="q"]').val());
        const t = $f.find('[name="type"]').val() || window.PXUTheme.theme_settings.search_option;
        window.location = `${this.vars.searchPath}?type=${t}&q=${q}*`;
      });
    });
  },

  getResults(query, $form) {
    const type = $form.find('[name="type"]').val() || window.PXUTheme.theme_settings.search_option;
    $.getJSON('/search/suggest.json', {
      q: query,
      resources: { type, limit: window.PXUTheme.theme_settings.search_items_to_display, options: { unavailable_products: 'last', fields: 'title' }}
    }).done((res) => {
      console.log('Risultati JSON:', res);
      const items = res.resources.results[type === 'product' ? 'products' : type] || [];
      this.displayResults(items, $form);
    });
  },

  displayResults(items, $form) {
    const $wrap = $form.find('.search__results-wrapper');
    const $list = $wrap.find('.search__results').empty();
    if (items.length) {
      items.forEach(item => {
        const thumb = item.image ? `<div class="thumbnail"><img src="${item.image.replace(/(\.[^.]*)$/, '_300x$1')}" /></div>` : '';
        const price = item.price ? `<span class="money">${window.PXUTheme.currency.symbol}${item.price}</span>` : '';
        $list.append(`<li class="item-result"><a href="${item.url}">${thumb}<div class="title">${item.title}<br><span class="price">${price}</span></div></a></li>`);
      });
      $wrap.addClass('results-found').show();  
    } else {
      $list.append('<li class="no-results">Nessun risultato</li>');
      $wrap.removeClass('results-found').show();
    }
  },

  unload() {
    $('[data-autocomplete-true] input').off('input');
    $(document).off('click focusout');
  }
};

/* ========= 4. ALTRI INIT ========== */
document.addEventListener('DOMContentLoaded', () => {
  const tpl = document.body.dataset.template || '';
  if (tpl === 'product' || tpl === 'quick_shop') {
    window.initProduct && window.initProduct();
  } else if (['collection','search','blog','article-list'].includes(tpl)) {
    window.initListing && window.initListing();
  }
});
